<div class="scheduler-container">
  @if (roster && !roster.length) {
    <div class="warning-message">
      Roster Length not defined.
    </div>
  }

  <div class="actions">
    @if (hasDivisions) {
      <button mat-raised-button color="primary" (click)="openAddShiftDialog()">
        <mat-icon>add</mat-icon>
        Add Shift
      </button>
    }
    @if (!hasDivisions) {
      <div class="no-divisions-message">
        Please add a division first before creating shifts
      </div>
    }
  </div>

  <div class="scheduler-wrapper" #schedulerContainer id="divisionGrid"></div>

  <div class="add-division-row">
    <button (click)="openNewDivisionDialog()" mat-raised-button color="primary">
      <mat-icon>add</mat-icon>
      Add Division
    </button>
  </div>
</div>
